import { addMethod, string } from 'yup';

export default () => {
  addMethod(string, 'atLeastOneNormalCharacter', function () {
    return this.test({
      name: 'atLeastOneNormalCharacter',
      message: "Can't contain only special characters",
      test: (value = '') => /[0-9a-zA-Z]/g.test(value),
    });
  });
};
